module.exports = __webpack_public_path__ + "img/addGst.0adf0c16.svg";